import { RfhColors } from '../config/florimixColors'
import { TransactionStatus } from '../types/api'
import type { TFunction } from 'i18next'

export type TransactionTabValue = 'open' | 'closed'

type TransactionStatusType = {
  label: string
  color: string
}

type InternalTransactionStatusType = {
  label: TransactionTabValue
  color: string
}

const statusMetaByStatus: Partial<
  Record<TransactionStatus, InternalTransactionStatusType>
> = {
  [TransactionStatus.New]: {
    label: 'open',
    color: RfhColors.dutchOrange,
  },
  [TransactionStatus.Processed]: {
    label: 'closed',
    color: RfhColors.darkGrey,
  },
}

export const getTransactionTabLabel = (
  tab: TransactionTabValue,
  t: TFunction
) => t(`transactions.tabs.${tab}`)

export const getTransactionStatusType = (
  status: TransactionStatus,
  t: TFunction
): TransactionStatusType => {
  const meta = statusMetaByStatus[status] ?? {
    label: 'closed',
    color: RfhColors.darkGrey,
  }

  return {
    label: getTransactionTabLabel(meta.label, t),
    color: meta.color,
  }
}

export const isTransactionInTab = (
  status: TransactionStatus,
  tab: TransactionTabValue
) => {
  if (tab === 'open') {
    return status === TransactionStatus.New
  }

  return status === TransactionStatus.Processed
}
